import { useCallback, useEffect, useRef, useState } from 'react';
import { useAppSelector } from '../../buildStore';
import { useConsentPromptDataV2 } from '../../hooks/useConsentPromptDataV2';
// @ts-ignore not typed
import { getSelectedThread } from '../../selected-thread/selectors/getSelectedThread';
import { isPersistedThread } from '../../threads/operators/isPersistedThread';
import { hasPersistedThreads } from '../../threads/selectors/hasPersistedThreads';
import { getSuggestedPrompts } from '../../widget-data/selectors/getSuggestedPrompts';
import { getIsUngatedForSpotlightSuggestedPrompts } from '../../widget-data/selectors/widgetDataSelectors';
export const useShowSuggestedPrompts = ({
  open
}) => {
  const [promptsRequested, setPromptsRequested] = useState(false);
  const hasExistingThread = isPersistedThread(useAppSelector(getSelectedThread));
  const hasAnyPersistedThreads = useAppSelector(hasPersistedThreads);
  const {
    consentRequired: requiresConsent
  } = useConsentPromptDataV2();
  const isUngated = useAppSelector(getIsUngatedForSpotlightSuggestedPrompts);
  const hasConfiguredPrompts = useAppSelector(getSuggestedPrompts).length > 0;
  const isFreshLauncher = isUngated && hasConfiguredPrompts && !hasExistingThread && !hasAnyPersistedThreads && !requiresConsent;
  const prevOpenRef = useRef(open);
  useEffect(() => {
    if (prevOpenRef.current && !open && isFreshLauncher) {
      setPromptsRequested(true);
    }
    prevOpenRef.current = open;
  }, [open, isFreshLauncher]);
  const collapsePrompts = useCallback(() => setPromptsRequested(false), []);
  const showPrompts = isFreshLauncher && promptsRequested && !open;
  return {
    showPrompts,
    isCollapsedButton: isFreshLauncher && !promptsRequested,
    collapsePrompts
  };
};